import React from 'react'
import './styles.scss'
import { Icon } from 'antd'
import {sanitize_path} from "../../../utils"

export default ({file, on_remove}) => (
  <div className={'presets-list'}>
    {
      (file.presets||[]).map((preset, index) =>
        <div key={index} className={'preset-item'}>
          <div>
            <span>{preset.category + '-' + preset.preset}</span>
            <span>{sanitize_path((preset.destination.bucket_name||'') + '/' + (preset.destination.path||''))}</span>
          </div>
          <Icon type="close" onClick={()=> on_remove(file, preset)}/>
        </div>
      )
    }
  </div>
)
